var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDfinity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1118,
    height: 560,
    viewBox: "0 0 1118 560",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845.918 0C783.626 0 715.417 33.9488 643.471 100.912C609.522 132.369 579.622 166.63 557.82 193.726C557.82 193.726 592.703 233.904 631.012 277.197C651.88 251.034 681.468 215.528 716.04 183.448C779.889 123.648 821.624 111.502 845.606 111.502C935.306 111.502 1008.19 186.874 1008.19 280C1008.19 372.191 935.306 447.564 845.606 448.498C841.246 448.498 836.263 447.875 830.033 446.63C856.196 458.776 884.538 467.497 911.012 467.497C1075.46 467.497 1107.85 353.815 1109.72 345.717C1114.39 324.85 1117.2 303.048 1117.2 280.623C1116.89 125.829 995.417 0 845.918 0Z",
    fill: "url(#paint0_linear_401_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.279 560C333.571 560 401.78 526.051 473.726 459.088C507.675 427.631 537.575 393.37 559.377 366.274C559.377 366.274 524.494 326.096 486.185 282.803C465.317 308.966 435.729 344.472 401.157 376.552C337.308 435.729 295.261 448.498 271.591 448.498C181.891 448.498 109.01 373.126 109.01 280C109.01 187.809 181.891 112.436 271.591 111.502C275.951 111.502 280.934 112.125 287.163 113.37C261.001 101.224 232.658 92.5028 206.185 92.5028C41.7353 92.1913 9.34371 205.873 7.47497 214.283C2.80311 235.15 0 256.952 0 279.377C0 434.171 121.468 560 271.279 560Z",
    fill: "url(#paint1_linear_401_6)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.485 185.94C378.42 168.498 290.59 97.1746 206.496 94.683C56.3737 90.9455 12.4582 199.955 8.4093 213.971C37.3748 91.8799 144.516 0.622914 271.591 0C375.306 0 480.267 101.846 557.82 193.726L558.131 193.415C558.131 193.415 593.014 233.593 631.324 276.885C631.324 276.885 674.928 328.276 721.023 373.437C739.088 390.879 826.607 461.268 910.701 463.76C1064.87 468.12 1107.54 352.881 1109.72 344.16C1081.38 467.186 973.927 558.754 846.229 559.377C742.514 559.377 637.553 457.531 559.689 365.651C559.689 365.962 559.377 365.962 559.377 366.274C559.377 366.274 524.494 326.096 486.185 282.803C486.496 282.803 442.892 231.101 396.485 185.94ZM8.4093 215.217C8.4093 214.905 8.4093 214.594 8.72076 214.283C8.4093 214.594 8.4093 214.905 8.4093 215.217Z",
    fill: "#29ABE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_6",
    x1: 700.11,
    y1: 44.3714,
    x2: 1084.08,
    y2: 431.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6841,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_401_6",
    x1: 417.185,
    y1: 515.691,
    x2: 33.2179,
    y2: 128.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8929,
    stopColor: "#522785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1117.51,
    height: 560,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfinity);
export default __webpack_public_path__ + "static/media/dfinity.34d023c9.svg";
export { ForwardRef as ReactComponent };